import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const loadCSS = (href, version) => {
  const fullHref = version ? `${href}?v=${version}` : href;

  // Prevent duplicate insertion by checking if the stylesheet is already loading
  if (document.querySelector(`link[href^="${href}"]`)) return;

  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = fullHref;
  document.head.appendChild(link);
};

const publicUrl = process.env.PUBLIC_URL || '';

// Hardcode the specific library versions you are currently using
// Need to change the version to avoid default browser caching and cache refresh
loadCSS(`${publicUrl}/css/bootstrap-icons.css`, '1.11.3');
loadCSS(`${publicUrl}/css/sgds-masthead.css`, '1.3.0');
loadCSS(`${publicUrl}/css/aos.css`, '2.3.4');

loadCSS('https://fonts.googleapis.com/css?family=Lato:400,700&display=swap');

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();